import React, { Fragment } from 'react'

function TopRoutes({ routes }) {
    const max = Math.max(1, ...(routes || []).map(r => r.count))

    if(!routes || routes.length === 0) {
        return (
            <Fragment>
                <p className='emptyState'>Aucun itinéraire sur les 6 derniers mois.</p>
            </Fragment>
        )
    }

  return (
    <Fragment>
        <ul className='topRoutes'>
            {routes.map((r, i) => (
                <li key={`${r.from}-${r.to}-${i}`}>
                    <div className='routeName'>
                        <span>{r.from}</span>
                        <span className='routeLine' aria-hidden='true'></span>
                        <span>{r.to}</span>
                    </div>
                    <div className='routeBarTrack'>
                        <div className='routeBar' style={{ width: `${(r.count / max) * 100}%` }}></div>
                    </div>
                    <span className='routeCount'>{r.count}</span>
                </li>
            ))}
        </ul>
    </Fragment>
  )
}

export default TopRoutes
